var exports = {
  "az": "Box__MdBuvd",
  "wy": "Box_1__KZFueI",
  "$n": "Button__ERic8F",
  "PA": "Truncate__dE6uzj",
  "Tr": "Button_1__x049jA",
};

module.exports = exports;
